import { Permission } from 'shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { CASDispositionType } from '../DispositionTypesContext/types'
import { EditFormItemsValues } from '../components/CreateEditFormItems/types'
import CreateEditFormItems from '../components/CreateEditFormItems'
import { useDispositionTypesContext } from '../DispositionTypesContext'

export function useEdit(): EditRowActionOptions<
  CASDispositionType,
  EditFormItemsValues
> {
  const { refetch, edit } = useDispositionTypesContext()

  return {
    permission: Permission.EditCASDispositionType,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      recordName: 'name',
      initialValues: ({ name, description }) => ({ name, description }),
      onOk: async ({ id, ...dispositionType }, { description, name }) => {
        if (
          description !== dispositionType.description ||
          name !== dispositionType.name
        ) {
          await edit({ id, description, name })
          refetch()
        }
      },
    },
  }
}
